import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', path: '/' },
  { label: '热门推荐', path: '/category/hot' },
  { label: '影视福利', path: '/category/movie' },
  { label: '综艺娱乐', path: '/category/variety' },
  { label: '音乐舞台', path: '/category/music' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
            : 'bg-transparent'
        }`}
      >
        <div className="mx-auto max-w-[1280px] px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link
              to="/"
              className="flex items-center gap-2 whitespace-nowrap cursor-pointer group"
            >
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-vidicon-line text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-bold text-foreground-950 font-heading group-hover:text-primary-500 transition-colors">
                福利视频大全
              </span>
            </Link>

            <nav className="hidden md:flex items-center gap-1">
              {navItems.map((item) => {
                const isActive = item.path === '/'
                  ? location.pathname === '/'
                  : location.pathname.startsWith(item.path);
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                      isActive
                        ? 'text-primary-500 bg-primary-50'
                        : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                    }`}
                  >
                    {item.label}
                  </Link>
                );
              })}
            </nav>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 cursor-pointer transition-colors"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="菜单"
            >
              <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200 animate-fade-in">
            <div className="px-4 py-3 space-y-1">
              {navItems.map((item) => {
                const isActive = item.path === '/'
                  ? location.pathname === '/'
                  : location.pathname.startsWith(item.path);
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`block px-3 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                      isActive
                        ? 'text-primary-500 bg-primary-50'
                        : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                    }`}
                  >
                    {item.label}
                  </Link>
                );
              })}
            </div>
          </div>
        )}
      </header>
      <div className="h-16"></div>
    </>
  );
}